/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Source from './Source';
//@import com/ibm/bi/platform/moser/client/cde/Source (loadtime) // superclass

/**
 * File data source
 * @author  nbalaba
 */
export default class FileSource extends Source{

	static SOURCE = "source";

	source = null;



	static fromJSON(json) {
		var source = new FileSource();
		source.setAssetId(json["asset_id"]);
		source.setProjectId(json["project_id"]);
		source.setSource(json["source"]);
		return source;
	}

	/**
	 * @return {Object}  the source
	 */
	getSource() {
		return this.source;
	}

	/**
	 * @param {Object} source  the source to set
	 */
	setSource(source) {
		this.source = source;
	}

	isFile() {
		return true;
	}

	isDatabase() {
		return false;
	}

	toJSON() {
		var json = super.toJSON();
		json["source"] = this.getSource();
		return json;
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/FileSource.js